// extracted by mini-css-extract-plugin
module.exports = {"tableHead":"Table_tableHead__2bdbm","bigColWidth":"Table_bigColWidth__3-MGa","biggerColWidth":"Table_biggerColWidth__3LtTT","row":"Table_row__2aLIa","col":"Table_col__bJrZL"};